import React, { useRef, useState } from 'react'
import {
  Animated,
  LayoutAnimation,
  Platform,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native'

import { isReviewInfoCard } from '@trivie/core/src/models/stores/game-store'

import {
  iconBook,
  iconChevronRight,
  iconCorrectQuestion,
  iconIncorrectQuestion,
} from '../../assets/icons'
import { color } from '../../theme'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'

interface ReviewPanelHeaderProps {
  item: any
  branding: any
  onClickInfoCard: any
}
export const ReviewPanelHeader = (props: ReviewPanelHeaderProps) => {
  const { item, branding, onClickInfoCard } = props
  const renderHeader = () => {
    if (isReviewInfoCard(item)) {
      if (Platform.OS === 'web') {
        return (
          <svg
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.25 1V16C17.25 16.1989 17.171 16.3897 17.0303 16.5303C16.8897 16.671 16.6989 16.75 16.5 16.75H3.75C3.35218 16.75 2.97064 16.908 2.68934 17.1893C2.40804 17.4706 2.25 17.8522 2.25 18.25H15C15.1989 18.25 15.3897 18.329 15.5303 18.4697C15.671 18.6103 15.75 18.8011 15.75 19C15.75 19.1989 15.671 19.3897 15.5303 19.5303C15.3897 19.671 15.1989 19.75 15 19.75H1.5C1.30109 19.75 1.11032 19.671 0.96967 19.5303C0.829018 19.3897 0.75 19.1989 0.75 19V3.25C0.75 2.45435 1.06607 1.69129 1.62868 1.12868C2.19129 0.56607 2.95435 0.25 3.75 0.25H16.5C16.6989 0.25 16.8897 0.329018 17.0303 0.46967C17.171 0.610322 17.25 0.801088 17.25 1Z"
              fill={branding?.review_background_text}
              fill-opacity="0.5"
            />
          </svg>
        )
      } else {
        return <SvgIcon size={24} src={iconBook} color={branding!.review_background_text} />
      }
    } else {
      if (Platform.OS === 'web') {
        return item.correct ? (
          <svg
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill={branding!.correct_answer}
              d="M10.4997 0.583252C4.74967 0.583252 0.0830078 5.24992 0.0830078 10.9999C0.0830078 16.7499 4.74967 21.4166 10.4997 21.4166C16.2497 21.4166 20.9163 16.7499 20.9163 10.9999C20.9163 5.24992 16.2497 0.583252 10.4997 0.583252ZM7.67676 15.4687L3.93717 11.7291C3.53092 11.3228 3.53092 10.6666 3.93717 10.2603C4.34342 9.85409 4.99968 9.85409 5.40593 10.2603L8.41634 13.2603L15.583 6.09367C15.9893 5.68742 16.6455 5.68742 17.0518 6.09367C17.458 6.49992 17.458 7.15617 17.0518 7.56242L9.14551 15.4687C8.74967 15.8749 8.08301 15.8749 7.67676 15.4687Z"
            />
          </svg>
        ) : (
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill={branding!.incorrect_answer}
              d="M10.4997 0.083252C4.73926 0.083252 0.0830078 4.7395 0.0830078 10.4999C0.0830078 16.2603 4.73926 20.9166 10.4997 20.9166C16.2601 20.9166 20.9163 16.2603 20.9163 10.4999C20.9163 4.7395 16.2601 0.083252 10.4997 0.083252ZM14.9788 14.9791C14.5726 15.3853 13.9163 15.3853 13.5101 14.9791L10.4997 11.9687L7.48926 14.9791C7.08301 15.3853 6.42676 15.3853 6.02051 14.9791C5.61426 14.5728 5.61426 13.9166 6.02051 13.5103L9.03093 10.4999L6.02051 7.4895C5.61426 7.08325 5.61426 6.427 6.02051 6.02075C6.42676 5.6145 7.08301 5.6145 7.48926 6.02075L10.4997 9.03117L13.5101 6.02075C13.9163 5.6145 14.5726 5.6145 14.9788 6.02075C15.3851 6.427 15.3851 7.08325 14.9788 7.4895L11.9684 10.4999L14.9788 13.5103C15.3747 13.9062 15.3747 14.5728 14.9788 14.9791Z"
            />
          </svg>
        )
      } else {
        return (
          <SvgIcon
            color={item.correct ? branding!.correct_answer : branding!.incorrect_answer}
            src={item.correct ? iconCorrectQuestion : iconIncorrectQuestion}
            size={24}
          />
        )
      }
    }
  }

  const [isExpanded, setIsExpanded] = useState(false)
  const textHeight = useRef(new Animated.Value(0)).current

  const expand = () => {
    LayoutAnimation.configureNext({ ...LayoutAnimation.Presets.linear, duration: 100 })
    setIsExpanded(!isExpanded)
  }

  return (
    <TouchableOpacity
      onPress={() => {
        if (isReviewInfoCard(item)) {
          onClickInfoCard(item.card_id)
        } else {
          expand()
        }
      }}
      // disabled={!isReviewInfoCard(item)}
      style={{
        ...QUESTION,
        // @ts-ignore
        transition: 'height 0.22s ease',
        marginBottom: isReviewInfoCard(item) ? 0 : 20,
      }}
    >
      <View style={{ paddingTop: 2, alignSelf: 'flex-start' }}>{renderHeader()}</View>
      <Text
        variant="body1Emphasized"
        disableLink
        style={{ ...QUESTION_TEXT, color: branding!.review_background_text }}
        text={isReviewInfoCard(item) ? item.card_title : item.question_text}
        numberOfLines={isExpanded ? 0 : 3}
      />
      {isReviewInfoCard(item) ? (
        Platform.OS === 'web' ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 12.705L10.41 17.295C10.02 17.685 9.38998 17.685 8.99998 17.295C8.60998 16.905 8.60998 16.275 8.99998 15.885L12.88 11.995L8.99998 8.11502C8.60998 7.72502 8.60998 7.09503 8.99998 6.70502C9.38998 6.31502 10.02 6.31502 10.41 6.70502L15 11.295C15.39 11.675 15.39 12.315 15 12.705Z"
              fill="white"
            />
          </svg>
        ) : (
          <SvgIcon size={24} src={iconChevronRight} color={branding!.review_background_text} />
        )
      ) : null}
    </TouchableOpacity>
  )
}

const QUESTION: ViewStyle = {
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 20,
}
const QUESTION_TEXT: TextStyle = {
  color: color.white,
  paddingLeft: 18,
  flex: 1,
}
